import { lazy } from "react";
import { ssrGetInitData } from "./getInitData";
import { getHeadTemplate } from "./getHeadTemplate";
import { ssrGetPageTemplate } from "./ssrGetPageTemplate";

const DesignerSsrPage = lazy(() => import("./designerSsr"));

export const designerPageSsrProps = {
    ssrEnabled: true,
    ssrComponent: (ssrProps: any) => <DesignerSsrPage {...ssrProps} />,
    ssrGetHeadTemplate: getHeadTemplate,
    ssrGetInitData,
    ssrGetPageTemplate,
    ssrOptions: {},
    notFoundComponent: (ssrProps: any) => <DesignerSsrPage {...ssrProps} />,
}

export const designerPageSsrEnabledProps = {
    ...designerPageSsrProps,
    ssrEnabled: true,
}
import { lazy } from "react";
import { ssrGetInitData } from "./getInitData";
import { getHeadTemplate } from "./getHeadTemplate";
import { ssrGetPageTemplate } from "./ssrGetPageTemplate";

const DesignerSsrPage = lazy(() => import("./designerSsr"));

export const designerPageSsrProps = {
    ssrEnabled: true,
    ssrComponent: (ssrProps: any) => <DesignerSsrPage {...ssrProps} />,
    ssrGetHeadTemplate: getHeadTemplate,
    ssrGetInitData,
    ssrGetPageTemplate,
    ssrOptions: {},
    notFoundComponent: (ssrProps: any) => <DesignerSsrPage {...ssrProps} />,
}

export const designerPageSsrEnabledProps = {
    ...designerPageSsrProps,
    ssrEnabled: true,
}
